module.exports = __webpack_public_path__ + "static/ebook-prematuridade-820540982edb180d1dffdd303d1c3983.png";